import React, {useState, useEffect} from "react";
import * as PropTypes from "prop-types";
import {isFunction, isNormalInteger} from "../../utils";
import {useTranslation} from "react-i18next";
import { Box, Typography } from "@mui/material";

const CompInputListNew = (props) => {
    const { t } = useTranslation('translation');

    const inputProps = {
        disabled: false,
        onChange: () => {
        }
    };
    const {rows, label, expectedTotal, error, onChange, ...componentProps} = props;
    const [currentRows, setRows] = useState(rows);

    useEffect(() => {
        setRows(rows);
    }, [rows]);

    if ('disabled' in componentProps) {
        inputProps.disabled = componentProps.disabled;
    }
    if (onChange) {
        inputProps.onChange = onChange;
    }

    const getTotal = (rows) => {
        return rows.reduce((total, obj) => isNormalInteger(obj.value) ? parseInt(obj.value) + total: total, 0)
    }

    const getValue = (value, row, rows) => {
        if(isFunction(value)) {
            return value(row, rows, getTotal(rows), expectedTotal);
        } else {
            if (value == null) value = '';
            return value;
        }
    }
    const changeValue = (row, value, index, e) => {
        e.preventDefault();
        const currentVal = currentRows[index].value ? currentRows[index].value : 0;
        if (isNaN(value)) {
            value = currentVal;
        }

        if(value < 0) value = 0;
        const total = expectedTotal ? expectedTotal : 0;
        const currentRow = currentRows[index];

        const newRows = [...currentRows];
        newRows[index] = {
            key: currentRow.key,
            value: value,
            label: currentRow.label
        };
        if(getTotal(newRows) > total && value > currentVal) return;

        setRows(newRows);
        if(isFunction(onChange)) {
            onChange(e);
        }
    }

    return (
        <Box className={`input-list-container ${error ? "error" : ""}`}>
            {label && (
                <Typography 
                    variant="caption" 
                    component="label" 
                    className="input-list-label"
                    sx={{ 
                        backgroundColor: '#F2F2F2 !important', 
                        paddingLeft: '4px',
                        paddingRight: '4px' 
                    }} 
                >
                    {label}
                </Typography>
            )}

        <Box className="input-list" {...componentProps}>
            {currentRows.map((row, index) => {
                return (
                <Box key={`input-list-row-${index}`} className="input-list-row">
                    <Typography variant="body2" className="input-list-row-label">
                        {row.label}
                    </Typography>
                    <input
                        type="number"
                        disabled={componentProps.disabled || isFunction(row.value)}
                        name={row.key}
                        min={0}
                        value={getValue(row.value, row, currentRows)}
                        onChange={(e) => changeValue(row, e.target.value, index, e)}
                        className="input-list-input"
                    />
                </Box>
            )})}

            <Box className="input-list-row input-list-row-total">
                <Typography variant="body2" className="input-list-row-label">
                    {t("components.registered")}
                </Typography>
                <Typography variant="body2" className="input-list-total-value">
                    {getTotal(currentRows)}/{expectedTotal}
                </Typography>
            </Box>
        </Box>

        {error && (
            <Typography variant="caption" color="error" className="input-list-error">
                {t(`errors.${error}`)}
            </Typography>
        )}
        </Box>
    );
}

CompInputListNew.propTypes = {
    label: PropTypes.string,
    rows: PropTypes.array,
    error: PropTypes.string,
    expectedTotal: PropTypes.number,
    onChange: PropTypes.func
};

export {CompInputListNew};